import { BroadcastChannel } from 'broadcast-channel';

export const SUCCESS_LOGIN_MESSAGE = 'success_login';

type BroadcastMessage = string | typeof SUCCESS_LOGIN_MESSAGE;

// Store active channels by channel name
const channels = new Map<string, BroadcastChannel>();

export const getBroadcastChannel = (username: string): BroadcastChannel => {
  const channelName = `login_${username}`;

  if (!channels.has(channelName)) {
    channels.set(channelName, new BroadcastChannel(channelName));
  }

  return channels.get(channelName)!;
};

export const sendBroadcastMessage = (username: string, message: BroadcastMessage): void => {
  const channel = getBroadcastChannel(username);
  channel.postMessage(message);
};

export const closeBroadcastChannel = (username: string): void => {
  const channelName = `login_${username}`;
  const channel = channels.get(channelName);

  if (channel) {
    channel.close();
    channels.delete(channelName);
  }
};
